import { render, staticRenderFns } from "./ModalPerfisUsuario.vue?vue&type=template&id=2666b324"
import script from "./ModalPerfisUsuario.vue?vue&type=script&lang=js"
export * from "./ModalPerfisUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalPerfisUsuario.vue?vue&type=style&index=0&id=2666b324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports